import { render, staticRenderFns } from "./CallToActionTwo.vue?vue&type=template&id=b15a98c2&scoped=true&"
import script from "./CallToActionTwo.vue?vue&type=script&lang=js&"
export * from "./CallToActionTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15a98c2",
  null
  
)

export default component.exports